import PosthogService from '~/services/posthog/PosthogService';
import { TTermsPopupSource } from './types';

export interface ITermsPopupAcceptedPayload {
  source: TTermsPopupSource;
}

/**
 * Fires when a user accepts the Terms & Conditions popup
 * Event: dental_portal:terms_popup:accepted
 */
export function fireTermsPopupAccepted(payload: ITermsPopupAcceptedPayload): void {
  PosthogService.getInstance().track('dental_portal:terms_popup:accepted', {
    source: payload.source,
  });
}
